import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Image from "../../../../../../../../../base/multimedia/image/index.js";
import { getCurrencySymbol } from "../../../../../../../../../../helpers/currency/index.js";
import { defaultWidth } from "../../../../constants.js";
import * as S from "../../../../styled.js";
import NormalMasonryCard from "../../../normalMasonryCard.js";
export const MasonryCard = ({ card , height , cardTitleVariant , isRegular  })=>{
    const { title , image: imageCard , description , price  } = card;
    const { class: _ , ...image } = imageCard ?? {};
    const width = defaultWidth;
    const normalMasonryCardDesktopProps = {
        width,
        height,
        cardTitleVariant,
        title,
        description,
        image
    };
    return isRegular ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            image && /*#__PURE__*/ _jsx(Image, {
                ...image,
                width,
                height,
                resize: {
                    width,
                    height
                },
                isLazy: true
            }),
            /*#__PURE__*/ _jsxs(S.MasonryRegularContainer, {
                "data-testid": "MasonryRegular",
                children: [
                    /*#__PURE__*/ _jsxs(S.MasonryRegularTitleWrapper, {
                        children: [
                            title && /*#__PURE__*/ _jsx(S.MasonryCardTitle, {
                                children: title
                            }),
                            description && /*#__PURE__*/ _jsx(S.MasonryCardDescription, {
                                children: description
                            })
                        ]
                    }),
                    price?.value && /*#__PURE__*/ _jsxs(S.MasonryCardRegularPrice, {
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                children: price?.from
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: `${price?.value}${getCurrencySymbol(price?.currency)}`
                            })
                        ]
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ _jsx(NormalMasonryCard, {
        ...normalMasonryCardDesktopProps
    });
};
export default MasonryCard;

//# sourceMappingURL=index.js.map